import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { Link as RouterLink } from 'react-router-dom';
import Snackbar from '@material-ui/core/Snackbar';
import Button from '@material-ui/core/Button';

const COOKIE_NAME = 'cookieconsent_status';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!Cookies.get(COOKIE_NAME)) {
      setVisible(true);
    }
  }, []);

  const saveDecision = (decision) => {
    Cookies.set(
      COOKIE_NAME,
      JSON.stringify({ decision, ts: new Date().toISOString() }),
      { expires: 365, secure: true, sameSite: 'Lax' }
    );
    setVisible(false);
  };

  const handleAccept = () => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
      });
    }
    saveDecision('accept');
  };

  const handleReject = () => {
    if (typeof window.gtag === 'function') {
      window.gtag('consent', 'update', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
      });
    }
    saveDecision('reject');
  };

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={visible}
      message={(
        <span>
          We use cookies to keep you signed in (essential) and, with your consent,
          to measure site usage via Google Analytics (analytics cookies).
          No advertising cookies are set without your approval.
          {' '}
          <RouterLink
            to="/privacy-policy"
            style={{ color: 'inherit', textDecoration: 'underline' }}
          >
            Privacy Policy
          </RouterLink>
        </span>
      )}
      action={[
        <Button key="reject" color="secondary" size="small" onClick={handleReject}>
          Reject Non-Essential
        </Button>,
        <Button
          key="accept"
          color="secondary"
          size="small"
          variant="contained"
          onClick={handleAccept}
        >
          Accept All
        </Button>,
      ]}
    />
  );
};

export default CookieConsent;
